"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowVersionCard = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const Schedule_1 = __importDefault(require("@material-ui/icons/Schedule"));
const core_ui_1 = require("@sierralabs/core-ui");
const core_2 = require("@sierralabs/core");
const user_ui_1 = require("@sierralabs/user-ui");
const useGetWorkflowVersions_1 = require("../hooks/useGetWorkflowVersions");
const WorkflowVersionCard = props => {
    const { workflow } = props;
    const { workflowVersions, isLoading, get } = (0, useGetWorkflowVersions_1.useGetWorkflowVersions)(workflow.id);
    (0, react_1.useEffect)(() => {
        get();
    }, [get, workflow]);
    return (react_1.default.createElement(core_1.Card, null,
        react_1.default.createElement(core_ui_1.CardTitle, null,
            react_1.default.createElement(Schedule_1.default, null),
            "Workflow Versions"),
        react_1.default.createElement(core_1.TableContainer, null,
            react_1.default.createElement(core_1.Table, null,
                react_1.default.createElement(core_1.TableHead, null,
                    react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, null, "Version"),
                        react_1.default.createElement(core_1.TableCell, null, "Published"),
                        react_1.default.createElement(core_1.TableCell, null, "Employee"))),
                react_1.default.createElement(core_1.TableBody, null,
                    isLoading && (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 3, padding: 'none' },
                            react_1.default.createElement(core_1.LinearProgress, null)))),
                    workflowVersions && workflowVersions.length > 0 ? (workflowVersions.map((workflowVersion) => (react_1.default.createElement(core_1.TableRow, { key: workflowVersion.id, hover: true },
                        react_1.default.createElement(core_1.TableCell, null, workflowVersion.version),
                        react_1.default.createElement(core_1.TableCell, null, (0, core_2.formatDate)(workflowVersion.created)),
                        react_1.default.createElement(core_1.TableCell, null,
                            react_1.default.createElement(user_ui_1.UserLink, { type: 'name', disableLink: true, user: workflowVersion.createdBy })))))) : (react_1.default.createElement(core_1.TableRow, null,
                        react_1.default.createElement(core_1.TableCell, { colSpan: 3 }, "No approved workflow versions"))))))));
};
exports.WorkflowVersionCard = WorkflowVersionCard;
exports.default = exports.WorkflowVersionCard;
//# sourceMappingURL=WorkflowVersionCard.js.map